export default __webpack_public_path__ + "static/media/etalon-horse-logo.2c031a23.svg";